import React, { ReactNode, MouseEventHandler } from 'react';

type ButtonProps = {
    type?: 'submit' | 'button' | 'reset';
    level?: string;
    label?: ReactNode;
    disabled?: boolean;
    loading?: boolean;
    isBlock?: boolean;
    onClick?: MouseEventHandler;
    faIcon?: string;
    className?: string;
    innerRef?: React.MutableRefObject<HTMLButtonElement>;
};

const Button = ({
    type = 'submit',
    level = 'primary',
    label,
    disabled,
    loading,
    isBlock,
    onClick,
    faIcon,
    className = '',
    innerRef,
}: ButtonProps) => (
    <button
        type={type}
        className={`btn btn-${level}${isBlock ? ' btn-block' : ''} ${className}`}
        disabled={disabled || loading}
        onClick={onClick}
        ref={innerRef}
    >
        {!loading && faIcon && <span className={`${faIcon}${label ? ' me-2' : ''}`} />}
        {loading && <i className={`mdi mdi-loading mdi-spin mdi-18px${label ? ' me-2' : ''}`} />}
        {label}
    </button>
);

export default Button;
